import React, { useState, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials, routeInfo } from "recoilState/GlobalState";
import { Routes } from "consts/Routes-App";
import { migraPasoGet } from "services/services-mia/migra";
import { MonitorPasosContent } from "./MonitorPasosContent";
import { log } from "utils/logger";

export default function MonitorPasos() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);

    const [loadingPasos, setLoadingPasos] = useState(true);
    const [errorPasos, setErrorPasos] = useState(null);
    const [pasos, setPasos] = useState([]);
    const [pasoDefault, setPasoDefault] = useState("");

    useEffect(() => {
        setRoute(Routes.migraMonitorTable);
    }, [setRoute]);

    useEffect(() => {
        if (!credentials?.merchantId) return;

        const fetchInicial = async () => {
            setLoadingPasos(true);
            try {
                const { result } = await migraPasoGet({}, credentials);
                const pasosActivos = (result || []).filter(p => p.migraPasoStatus !== "B");

                setPasos(pasosActivos);
                setPasoDefault(pasosActivos[0]?.migraPasoId ?? "");
                setErrorPasos(null);
            } catch (err) {
                log.error("Error cargando pasos del Monitor:", err);
                setErrorPasos("No se pudieron cargar los pasos disponibles");
            } finally {
                setLoadingPasos(false);
            }
        };

        fetchInicial();
    }, [credentials]);

    return (
        <>
            {!loadingPasos && pasoDefault !== "" && (
                <MonitorPasosContent
                    pasos={pasos}
                    pasoDefault={pasoDefault}
                    credentials={credentials}
                    errorPasos={errorPasos}
                    loadingPasos={loadingPasos}
                />
            )}
            {loadingPasos && (
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    Cargando pasos...
                </div>
            )}
        </>
    );
}
